export default "__VITE_ASSET__sguiOQph__"